import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const RequireAuth = ({ children }) => {
	const { authenticated, forcePasswordChange } = useSelector((s) => s.auth);
	if (forcePasswordChange) return <Navigate to="/change-password" replace />;
	if (!authenticated) return <Navigate to="/login" replace />;
	return children;
};

export default RequireAuth;


